import { i18n } from '../services/i18n/i18n';
import { i18nMobile } from '../services/i18n/i18n.mobile';
export const useT = () => {
    return {
        t: i18n.t,
        language: i18n.language
    };
};
export const useMobileT = () => {
    return {
        t: i18nMobile.t,
        language: i18nMobile.language
    };
};
//# sourceMappingURL=useT.js.map